export default [
  {
    path: '/regulatoryView/healthDeliver',
    name: 'healthDeliver',
    meta: {
      title: '投递系统健康状态'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulatoryView/healthDeliver.vue')
  },
  {
    path: '/regulatoryView/healthRun',
    name: 'healthRun',
    meta: {
      title: '运营系统健康状态'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulatoryView/healthRun.vue')
  },
  {
    path: '/regulatoryView/wiring',
    name: 'wiring',
    meta: {
      title: '电器通断状态'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulatoryView/wiring.vue')
  },
  {
    path: '/regulatoryView/environmental',
    name: 'environmental',
    meta: {
      title: '环境精灵数据'
    },
    component: () =>
      import(/* webpackChunkName: "dynamicList" */ '@/views/regulatoryView/environmental.vue')
  }
]
